export default __webpack_public_path__ + "static/media/posters.2c582d43.webp";